<template>
  <div class="warp">
    <div class="bc"></div>
    <div id="warp-page" ref="warpPage" class="warp-page">
      <img
        :style="`height: ${height2}px`"
        src="https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/pc/bg.jpg"
        alt=""
      />
      <div class="page">
        <div class="left">
          <div class="left_logo">
            <img
              src="https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/pc/logo.png"
              alt=""
            />
          </div>
          <div class="left_module_one">
            <div class="left_module_one_top">
              <div class="left_module_one_top-state">
                <!-- <img :src="`${t.livetime*1000<=new Date().getTime()?btn1:btn2}`" alt=""> -->
                <img
                  src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_73e4d8a99348421b80ea9bd8a8715cb2.png"
                  alt=""
                />
                <!-- https://live.photoplus.cn/live/67049967 -->
                <!-- https://live.photoplus.cn/live/58563398 -->
                <a href="https://live.photoplus.cn/live/1075855">
                  <img
                    src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_2fea2d46e3354704815e0dd0baf29125.png"
                    alt=""
                  />
                </a>
                <img
                  src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_521c68c888ff44748fac2b8f0be622bd.png"
                  @click="isShow = true"
                  style="cursor: pointer"
                  alt=""
                />
              </div>
            </div>
            <x-swiper
              :liveId.sync="liveId"
              :videoList="allList.length ? allList : liveList"
            ></x-swiper>
          </div>
          <div class="left_module_two">
            <div style="min-height: 60px">
              <div class="left_module_two-top">
                <div
                  class="left_module_two-top-btn"
                  @click="handleTab('tab1', 0)"
                >
                  <img :src="tab1 === 0 ? btn1 : btn4" alt="" />
                  <div
                    :class="`left_module_two-top-btn-text ${
                      tab1 !== 0 ? 'left_module_two-active' : ''
                    }`"
                  >
                    9月21日
                  </div>
                </div>
                <!-- <div
                  style="margin-left: -0.05rem"
                  class="left_module_two-top-btn"
                  @click="handleTab('tab1', 1)"
                >
                  <img :src="tab1 === 1 ? btn3_1 : btn3_2" alt="" />
                  <div
                    :class="`left_module_two-top-btn-text ${
                      tab1 !== 1 ? 'left_module_two-active' : ''
                    }`"
                  >
                    9月8日
                  </div>
                </div>
                <div
                  style="margin-left: -0.05rem"
                  class="left_module_two-top-btn"
                  @click="handleTab('tab1', 2)"
                >
                  <img :src="tab1 === 2 ? btn3_1 : btn3_2" alt="" />
                  <div
                    :class="`left_module_two-top-btn-text ${
                      tab1 !== 2 ? 'left_module_two-active' : ''
                    }`"
                  >
                    9月9日
                  </div>
                </div> -->
                <div
                  class="left_module_two-top-btn"
                  @click="handleTab('tab1', 1)"
                >
                  <img :src="tab1 === 1 ? btn3 : btn2" alt="" />
                  <div
                    :class="`left_module_two-top-btn-text ${
                      tab1 !== 1 ? 'left_module_two-active' : ''
                    }`"
                  >
                    9月22日
                  </div>
                </div>
              </div>
            </div>
            <div class="left_module_two-swiper" style="min-height: 2.27rem">
              <swiper :liveId.sync="liveId" :videoList="liveList"></swiper>
            </div>
          </div>
          <div class="left_module_three">
            <img
              src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_04ac51792fa14a718c2e06102a663514.png"
              alt=""
            />
            <a
              href="https://h5.sauos.com/project/dbkj/202002/"
              class="left_module_three-btn"
            ></a>
            <a
              href="https://h5.sauos.com/project/dbkj/2021jszydh/ "
              class="left_module_three-btn"
            ></a>
            <a
              class="left_module_three-btn"
              href="https://h5.sauos.com/project/dbkj/2022jszydh/"
            ></a>
            <a
              class="left_module_three-btn"
              href="https://h5.sauos.com/project/dbkj/2023jszydh/"
            ></a>
            <a
              class="left_module_three-btn"
              href="https://2024innomatch.sauos.net/"
            ></a>
          </div>
        </div>
        <div class="right">
          <div class="right_logo">
            <img
              src="https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/pc/logo1.png"
              alt=""
            />
          </div>
          <div class="right_video">
            <img
              src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_4cdca6285c3c4cb68618e28544ef87d1.png"
              alt=""
            />
            <player-video
              ref="videoOne"
              padding="0.34rem 0.25rem 0.39rem"
              :liveInfo="liveInfo"
              :poster="liveInfo.live.kvImg"
              @childData="updateData"
            ></player-video>
            <img
              class="KV"
              v-show="KV"
              @click="KVimg()"
              src="https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/pc/kv.png"
              alt=""
            />
            <div class="right_video-href">
              <!-- <a href="https://live.photoplus.cn/live/67049967">点击查看精彩瞬间</a> -->
            </div>
          </div>

          <!--v-show="
              liveInfo.live.languageStatus &&
              parseInt(liveInfo.live.languageSpecies)
            " -->
          <!-- v-show="this.liveInfo.live.remark" -->
          <div class="right_bottom" v-show="this.liveInfo.live.remark">
            <img v-show="!imgBtn" :src="this.liveInfo.live.remark.split('/')[this.liveInfo.live.remark.split('/').length - 1] == 1 ? btn5 : this.liveInfo.live.remark.split('/')[this.liveInfo.live.remark.split('/').length - 1] == 2 ? btn6 : btn7" alt="" />
            <a
              href="https://wx.vzan.com/live/tvchat-1972777671?v=1693748766301"
            >
              <img
                v-show="imgBtn"
                src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_55b3ef56d89c4fa580cee2801ca053b6.png"
                alt=""
            /></a>
            <!-- <img src="@/assets/btnS1.png" alt="" /> -->
            <!-- 中葡英 -->
            <div class="right_bottom_btns" v-show="inBtn1">
              <div
                :class="['right_bottom_btns-btn1', this.liveInfo.live.remark.split('/').length === 3 ? 'two' : '']"
                @click="handleTab('tab', 0)"
              ></div>
              <div
                :class="['right_bottom_btns-btn1', this.liveInfo.live.remark.split('/').length === 3 ? 'two' : '']"
                @click="handleTab('tab', 1)"
              ></div>
              <div
              v-if="this.liveInfo.live.remark.split('/').length === 4"
                class="right_bottom_btns-btn1"
                @click="handleTab('tab', 2)"
              ></div>
              <!-- <div
                class="right_bottom_btns-btn1"
                @click="handleTab('tab', 3)"
              ></div> -->
            </div>
            <!-- 中韩 -->
            <div class="right_bottom_btns" v-show="inBtn2">
              <div
                class="right_bottom_btns-btn"
                @click="handleTab('tab', 0)"
              ></div>
              <div
                class="right_bottom_btns-btn"
                @click="handleTab('tab', 1)"
              ></div>
            </div>
          </div>
        </div>
        <div class="module-btns">
          <!-- <img class="img" src="@/assets/btn12.1.png" alt="" /> -->
          <!-- <a href="https://www.innomatch.net/home" class="btn1">
            <img class="img1" src="@/assets/btn12.png" alt=""
          /></a>
          <a href="https://wxaurl.cn/bB8xAjSvs5g" class="btn2">
            <img class="img2" src="@/assets/btn13_2_1.png" alt=""
          /></a> -->
          <div style="padding-top: 6.5rem"></div>
          <a href="https://www.innomatch.net">
            <img
            src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_90dd98eaf9ea46fa82932d8173bee63d.png"
            alt=""
          />
          </a>
          <a href="https://xjt.pujiangforum.cn/" style="margin-top: 0.3rem;">
            <img
              src="../../../assets/avatar.png"
              alt=""
            />
            <span style="display: inline-block; text-align: center; width: 100%; color: #f1f1f1;margin-top: 0.05rem;">小江豚智能体</span>
          </a>
        </div>
      </div>
      <!-- <div class="pv">
      <van-icon name="friends-o"></van-icon> 1648168
    </div> -->
    </div>

    <!-- 宣传片 -->
    <div class="popup" v-show="isShow">
      <x-player-video ref="videoTwo"></x-player-video>
      <div class="close" @click="isShow = false">
        <van-icon name="cross"></van-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { getLiveList, getLiveInfo } from '@/api/api.js'
import PlayerVideo from '@/components/video/index'
import XPlayerVideo from '@/components/video/index-two'
import Swiper from '@/components/swiper/index'
import XSwiper from '@/components/x-swiper/index'
import { mapGetters } from 'vuex'
export default {
  components: { PlayerVideo, XPlayerVideo, Swiper, XSwiper },
  data() {
    return {
      tab: 0,
      tab1: 0,
      btn1: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/btn1.png',
      btn2: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/btn2.png',
      btn3: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/btn2.png',
      btn3_1:
        'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_54c1ee3162154c2183d25bcef87c1557.png',
      btn3_2:
        'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_c2604ae7bb7841e0812f99fb31414873.png',
      btn4: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/btn1.png',
      btn5: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/lang3.png',
      btn6: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/lang2.png',
      btn7: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/lang1.png',
      ids: [
        { chinese: 372, english: 325 },
        { chinese: 373, english: 324 }
        // { chinese: 362, english: 324 },
        // { chinese: 363, english: 324 }
      ],
      liveId: null,
      liveInfo: {
        live: {},
        liveStream: {}
      },
      allList: [],
      liveList: [],
      // height: '',
      isShow: false,
      height2: '',
      inBtn: '',
      imgBtn: '',
      inBtn1: false,
      inBtn2: false,
      inb1: '',
      inb2: '',
      inb3: '',
      inb4: '',
      KV: true
    }
  },
  computed: {
    ...mapGetters(['height'])
  },
  mounted() {
    window.addEventListener('mousedown', this.handleonmousedown)
    console.log('pc')
    document.body.style.overflowY = 'hidden'
    this.handleHeight()
    this.handleTab()
    window.addEventListener('resize', () => {
      console.log('ok')
      this.handleHeight()
    })
  },
  watch: {
    liveId(n, o) {
      if (n !== o) {
        this.tab = 0
        this.getLiveInfo(n)
      }
      if (n === 1555) {
        this.imgBtn = true
      }
    },
    isShow(n) {
      if (n) {
        this.$refs.videoOne.pause()
        this.$refs.videoTwo.play()
      } else {
        this.$refs.videoTwo.pause()
      }
    }
  },
  methods: {
    updateData(value) {
      this.KV = value
    },
    close() {
      this.$refs.videoOne.pause()
    },
    handleHeight() {
      this.$nextTick(() => {
        var width =
          document.documentElement.clientWidth || document.body.clientWidth
        if (width / this.height >= 16 / 9) {
          this.height2 = this.height
          var pageWidth = this.height * (16 / 9)
          var fontSize = (pageWidth / 1920) * 100
          document.getElementsByTagName('html')[0].style['font-size'] =
            fontSize + 'px'
        }
      })
    },

    handleTab(value, tab) {
      // console.log(value, tab)
      if (value && this[value] === tab) return
      this[value] = tab
      switch (value) {
        case 'tab':
          let inb = ''
          if (this.inBtn) {
            if (this.tab === 0) {
              console.log(this.inb1)
              if (this.inb1) {
                inb = this.inb1
              }
            } else if (this.tab === 1) {
              console.log(this.inb2)
              if (this.inb2) {
                inb = this.inb2
              }
            } else if (this.tab === 2) {
              console.log(this.inb3)
              if (this.inb3) {
                inb = this.inb3
              }
            } else if (this.tab === 3) {
              console.log(this.inb4)
              if (this.inb4) {
                inb = this.inb4
              }
            }
            this.getLiveInfo(inb)
          } else {
          const id = parseInt(this.liveInfo.live.remark)
          console.log(id)
          this.getLiveInfo(id)
          }
          break
        case 'tab1':
          this.tab = 0
          if (this.tab1 === 0) {
            const id = this.ids[0].chinese
            this.getLiveList(id)
          } else if (this.tab1 === 1) {
            const id = this.ids[1].chinese
            this.getLiveList(id)
          } else if (this.tab1 === 2) {
            const id = this.ids[2].chinese
            this.getLiveList(id)
          } else if (this.tab1 === 3) {
            const id = this.ids[3].chinese
            this.getLiveList(id)
          }
          break
        // eslint-disable-next-line no-fallthrough
        default:
          this.getLiveList()
          break
      }
    },
    getLiveList(id = 372) {
      getLiveList({ homeId: id, page: 1, limit: 999, liveType: 2 }).then(
        (res) => {
          this.liveList = res.page.list
          // console.log(this.liveList)
          this.liveId = this.liveList[0].liveId
          console.log(this.liveId)
          const time = new Date().getTime()
          this.allList = []
          this.liveList.forEach((t) => {
            if (t.livetime * 1000 <= time) {
              this.allList.push(t)
            }
          })
        }
      )
    },
    getLiveInfo(id) {
      console.log(id)
      const data = { openId: 'openId' }
      getLiveInfo(data, id).then((res) => {
        this.liveInfo = res.data
        var btn = this.liveInfo.live.remark
        // console.log(btn)
        this.inBtn = btn.includes('/')
        if (this.inBtn && id !== 1555) {
          this.inBtn1 = true
          this.inBtn2 = false
        } else if (!this.inBtn && id !== 1555) {
          this.inBtn2 = true
          this.inBtn1 = false
        } else {
          this.inBtn2 = false
          this.inBtn1 = false
        }
        console.log(this.inBtn)
        var arr = btn.split('/')
        console.log(arr[0] + '<', arr[1] + '<', arr[2] + '<', arr[3] + '<')
        this.inb1 = arr[0]
        this.inb2 = arr[1]
        this.inb3 = arr[2]
        this.inb4 = arr[3]
        // console.log(this.liveInfo.live)
      })
    },
    KVimg() {
      this.KV = false
    }
  }
}
</script>

<style lang="scss" scoped>
$left-logo-padding-top: 0.6rem;
$margin-left_one: 0.4rem;
$margin-right_one: 0.35rem;
$margin_bottom_one: 0.3rem;
$padding_top_one: 0.32rem;
$module-two-margin-bottom: 0.4rem;
$width_left: 5.3rem;
$width_all: 5.7rem;
$width_right-logo: 3rem;
$width_right_btn: 5rem;
$width_video: 10.92rem;
$width_right: 11.3rem;
$color_f: #fff;
$color_a: #a6939a;

.warp {
  display: flex;
  width: 100%;
  height: 100%;
  align-content: center;
}
.bc {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: #013a67;
  background-image: url('https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/pc/bbg.jpg');
  background-size: cover;
}
.warp-page {
  // max-width: 1920px;
  margin: auto;
  // width: 100%;
  position: relative;
  img {
    max-width: 100%;
    // width: 100%;
  }
  .pv {
    right: 0.1rem;
    top: $left-logo-padding-top;
    position: absolute;
    font-size: 0.25rem;
    color: $color_f;
    padding: 0.05rem 0.1rem;
    border-radius: 0.2rem;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }
}
.page {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  // background: url('~@/assets/bg1.jpg') no-repeat;
  // background-size: cover;
  display: flex;
  // padding-bottom: 48px;
  img {
    width: 100%;
  }
  .left {
    margin-right: 0.4rem;
    &_logo {
      width: 3.5rem;
      margin-left: $margin-left_one;
      margin-bottom: 0.32rem;
      padding-top: $left-logo-padding-top;
    }
    &_module_one {
      width: $width_left;
      margin-left: $margin-left_one;
      // margin-bottom: $margin_bottom_one;
      color: $color_f;
      min-height: 2.3rem;
      &_top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 7px;
        &-state {
          display: -webkit-box;
          width: 3.6rem;
          img {
            width: 1.65rem;
            // margin: 0 0.05rem;
          }
        }
        &-date {
          font-size: 0.28rem;
          margin-top: 0.45rem;
        }
      }
      &-desc {
        font-size: 0.28rem;
        text-align: justify;
        letter-spacing: 2px;
        margin-bottom: 0.5rem;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        line-clamp: 2;
        -webkit-line-clamp: 2; //显示几行
      }
    }
    &_module_two {
      width: $width_left;
      margin-left: $margin-left_one;
      margin-bottom: $module-two-margin-bottom;
      &-active {
        color: $color_a !important;
      }
      &-top {
        display: flex;
        justify-content: space-between;
        // min-height: 60px;
        margin-bottom: 0.3rem;
        &-btn {
          position: relative;
          cursor: pointer;
          flex: 1;
          &-text {
            position: absolute;
            display: flex;
            font-size: 0.21rem;
            margin-top: -0.03rem;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            color: $color_f;
          }
        }
      }
    }
    &_module_three {
      width: $width_all;
      position: relative;
      &-btn {
        position: absolute;
        display: block;
        width: 0.66rem;
        height: 0.61rem;
        cursor: pointer;
      }
      &-btn:nth-of-type(1) {
        top: 0.9rem;
        left: 0.4rem;
      }
      &-btn:nth-of-type(2) {
        top: 1.15rem;
        left: 1.5rem;
      }
      &-btn:nth-of-type(3) {
        top: 1.1rem;
        left: 2.4rem;
      }
      &-btn:nth-of-type(4) {
        top: 0.4rem;
        left: 3rem;
      }
      &-btn:nth-of-type(5) {
        top: 0.3rem;
        left: 3.9rem;
      }
    }
  }
  .right {
    width: $width_right;
    flex-shrink: 0;
    // border: 1px solid red;
    &_logo {
      width: $width_right-logo;
      margin: auto;
      padding-top: 0.6rem;
      // margin-bottom: 0.2rem;
      // border: 1px solid;
    }
    &_video {
      width: $width_video;
      margin: auto;
      position: relative;
      &-href {
        font-size: 0.2rem;
        position: absolute;
        bottom: -0.05rem;
        right: 0.22rem;
        a {
          color: $color_f !important;
        }
      }
      &-box {
        width: 100%;
        height: 100%;
        position: absolute;
        box-sizing: border-box;
        padding: 0.8rem;
        top: 0;
        left: 0;
      }
    }
    &_bottom {
      width: 4.6rem;
      margin: 0.2rem auto;
      position: relative;

      // border: 1px solid red;
      img {
        // border: 1px solid bisque;
        position: absolute;
      }
      &_btns {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &-btn {
          flex: 1;
          height: 0.35rem;
          cursor: pointer;
          // border: 1px solid yellow;
        }
        &-btn1 {
          // border: 1px solid red;
        }
        &-btn1:nth-of-type(3) {
          top: 0;
          left: 68%;
        }
        &-btn1 {
          width: 32%;
          height: 100%;
          position: absolute;
          // border: 1px solid yellow;
          cursor: pointer;
          height: 0.35rem;
          top: 0;
          left: 0;
        }
        &-btn1:nth-of-type(2) {
          width: 33%;
          top: 0;
          left: 33%;
        }
        &-btn1:nth-of-type(3) {
          width: 35%;
          top: 0;
          left: 65%;
        }
        &-btn1.two, &-btn1:nth-of-type(2).two {
          width: 50%;
        }
        &-btn1:nth-of-type(2).two {
          left: 50%;
        }
        // &-btn1:nth-of-type(4) {
        //   top: 0;
        //   left: 70%;
        // }
      }
    }
  }

  .module-btns {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // height: 100%;
    a {
      margin-bottom: 0rem;
    }
    img {
      width: 60%;
      margin: 0 auto;
    }
  }
}
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  .close {
    position: absolute;
    z-index: 9999;
    color: #fff;
    font-size: 0.4rem;
    font-weight: 900;
    top: 0.6rem;
    right: 0.5rem;
    cursor: pointer;
    transition: all 0.5s;
  }
  .close:hover {
    transform: rotate(90deg);
  }
  &-video {
    width: 10rem;
    height: 5.62rem;
  }
}
.page::-webkit-scrollbar {
  display: none;
}
.KV {
  position: absolute;
  width: 95.8% !important;
  top: 4.5%;
  z-index: 999;
  left: 2%;
}
</style>
